import { Progress, Spin } from 'antd';
import ErrorAlert from 'components/ui/ErrorAlert';
import gql from 'graphql-tag';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-apollo';
import { Link } from 'react-router-dom';
import { ProgressColor } from '.';

const query = gql`
  query classifiedEventCountByAccount($filters: ClassifiedEventStatFilters, $nextKey: String) {
    classifiedEventCountByAccount(filters: $filters, nextKey: $nextKey) {
      duration
      total
      nextKey
      items {
        key
        count
      }
    }
  }
`;

interface Props {
  accounts;
}

export default function EventCountByAccount(props: Props) {
  const { accounts } = props;

  const { data, error, loading } = useQuery(query);
  const { classifiedEventCountByAccount } = data || {};
  const { items } = classifiedEventCountByAccount || {};

  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    const total = items
      ?.sort((a, b) => b.count - a.count)
      .reduce((accumulator, item) => {
        const { count = 0 } = item;
        return accumulator + count;
      }, 0);
    setTotal(total);
  }, [items]);

  return (
    <>
      {loading && <Spin style={{ marginRight: '8px' }} />}

      {error && <ErrorAlert error={error} />}

      {!loading && items?.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Percent</th>
              <th>Count</th>
              <th>Account</th>
            </tr>
          </thead>
          <tbody>
            {items?.map((item) => {
              const { key: accountId, count } = item;
              const account = accounts?.find((a) => a.account_id === accountId);
              const { nickname, name, assumerole_account_id: cloudAccountId } = account;

              const percent = Number(((count / total) * 100).toFixed(1));

              return (
                <tr key={accountId}>
                  <td style={{ width: 170 }}>
                    <Progress percent={percent} strokeColor={ProgressColor} status="normal" />
                  </td>
                  <td>{count?.toLocaleString()}</td>
                  <td>
                    <Link
                      to={`/events?eventType=all&accountId=${account.assumerole_account_id}`}
                      title="View events for this account"
                    >
                      {nickname || name || cloudAccountId}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
